<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

  .new-b2c-value-item {
    margin-bottom: 16px;

    .con {
      display: flex;
      align-items: center;

      .con_name {
        font-family: PingFangSC-Light;
        .name_question {
          width: 20px;
          height: 20px;
          margin-top: -1px;
          margin-left: 8px;
          vertical-align: middle;
        }
      }

      .qc-tip img {
        width: 22px;
        height: 22px;
        margin-left: 8px;
      }
    }

    .line {
      position: relative;
      display: inline-block;
      flex: 1;
      height: 1px;
      margin: 0 16px;

      &::after {
        @include hairline(#d8d8d8);
        border-bottom-width: 1px;
        border-bottom-style: dashed;
      }
    }

    .abnormal {
      color: #ff9429;
    }

    .desc-info {
      position: relative;
      margin-top: 16px;
      padding-left: 20px;
      line-height: 28px;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 9px;
        height: 7px;
      }
    }

    .desc-info::before {
      position: absolute;
      top: 0;
      left: 3.5px;
      width: 1px;
      height: 100%;
      border-left: 1px dashed #d8d8d8;
      content: '';
    }

    .value_item_img {
      position: relative;
      z-index: 10;
      width: 36px;
      height: 36px;
      margin-left: 16px;

      &.value_item_img_active {
        position: relative;
        top: -4px;
        left: -3px;

        &::after {
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          box-sizing: border-box;
          width: 36px;
          height: 36px;
          margin-top: 6px;
          margin-left: 6px;
          background: #d9d9d9;
          border: 0.5px solid #999999;
          border-radius: 4px;
          content: '';
        }

        img {
          width: 36px;
          height: 36px;
          border: 0.5px solid #fff;
          border-radius: 6px;
        }
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }

      &::before {
        position: absolute;
        top: -10px;
        right: -10px;
        bottom: -10px;
        left: -10px;
        content: '';
      }

      .value_examples {
        position: absolute;
        top: 50%;
        left: 0;
        color: #111;
        font-weight: 300;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 27px;
        white-space: nowrap;
        transform: translateY(-50%);

        // margin-top: -1px;
        &::after {
          @include hairline(#111);
          border-bottom-width: 1px;
        }
      }
    }
  }
</style>

<template>
  <div class="new-b2c-value-item">
    <div class="con">
      <div class="con_name" @click="itemClick(qcData.isNormal)">
        <span class="k">{{ title }}</span>
        <img
          v-if="
            qcData.smallEncyclopediaPic || (qcData.standardDefines && qcData.standardDefines.length)
          "
          class="name_question"
          :src="
            $setPicSize(
              'https://pic3.zhuanstatic.com/zhuanzh/280e9ecd-2f3c-444b-a7a7-5a832773342c.png'
            )
          "
        />
      </div>
      <span class="line"></span>
      <span :class="['v', { abnormal: !qcData.isNormal }]">{{ qcData.value }}</span>
    </div>
    <div v-if="qcData.desc" class="desc-info">
      <img src="https://pic5.zhuanstatic.com/zhuanzh/31c17c30-de4c-4eed-b2c8-acd43617a03a.png" />
      {{ qcData.desc }}
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: [String],
        required: true,
      },
      qcData: {
        type: [Object],
        required: true,
      },
      indicatorGroup: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        flawedImgList: [],
      }
    },
    methods: {
      // 查看质检项目
      itemClick(val) {
        console.log('val', val)
        const qcData = this.qcData
        if (
          qcData.smallEncyclopediaPic ||
          (qcData.standardDefines && qcData.standardDefines.length)
        ) {
          this.$emit('itemClick')
        }
      },
    },
  }
</script>
